import React, { Component } from 'react'

import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import get from 'lodash/get'

import type { ColumnConfig } from './types'

type SimpleTableProps = {
  config: ColumnConfig[]
  data: any
  hover?: boolean
  striped?: boolean
}

export default class SimpleTable extends Component<SimpleTableProps> {
  static defaultProps = {
    hover: false,
    striped: false,
  }

  renderCell = (row: any) => (cell: ColumnConfig, cellIndex: number) => {
    return <TableCell key={cellIndex}>{cell.render ? cell.render(row) : get(row, cell.field ?? '') || ''}</TableCell>
  }

  renderRow = (row: any, rowIndex: number) => {
    const { config, hover, striped } = this.props

    return (
      <TableRow
        hover={hover}
        key={rowIndex}
        sx={striped ? { '&:nth-of-type(odd)': { backgroundColor: '#f5f5f5' } } : undefined}>
        {config.map(this.renderCell(row))}
      </TableRow>
    )
  }

  render() {
    const { config, data } = this.props

    return (
      <Table>
        <TableHead>
          <TableRow>
            {config.map((cell: any, index: number) => (
              <TableCell key={index} style={cell.style}>
                {cell.title}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>{data.map(this.renderRow)}</TableBody>
      </Table>
    )
  }
}
